import React from "react";
import { Badge } from "../ui/badge";
import { cn } from "../../lib/utils";

export interface EDSBadgeProps {
  children: React.ReactNode;
  className?: string;
  variant?:
    | "default"
    | "secondary"
    | "outline"
    | "destructive"
    | "success"
    | "warning"
    | "info";
  style?: React.CSSProperties;
}

const EDSBadge = React.forwardRef<HTMLSpanElement, EDSBadgeProps>(
  ({ children, className, variant = "default", style, ...props }, ref) => {
    return (
      <Badge
        ref={ref}
        variant={variant}
        className={cn("eds-badge", className)}
        style={style}
        {...props}
      >
        {children}
      </Badge>
    );
  }
);

EDSBadge.displayName = "EDSBadge";

export { EDSBadge };
